import React from 'react'
import { Route, Redirect, IndexRedirect } from 'react-router'
import loadable from 'hoc/Loadable'

const CustomersApp = loadable(() =>
  import(/* webpackChunkName: "CustomersApp" */ './App')
)
const CustomersCreateApp = loadable(() =>
  import(/* webpackChunkName: "CustomersCreateApp" */ './CreateApp')
)
const CustomersSettings = loadable(() =>
  import(/* webpackChunkName: "CustomersSettings" */ './Settings')
)
const CustomersSettingsSources = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsSources" */ './Settings/Sources'
  )
)
const CustomersSettingsConnectionPolicyApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsConnectionPolicyApp" */ './Settings/ConnectionPolicy/ConnectionPolicyApp'
  )
)

const CustomersSettingsLabelsApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsLabelsApp" */ './Settings/labels/LabelsApp'
  )
)
const CustomersSettingsWarehouseSourcesList = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsWarehouseSourcesList" */ './Settings/WarehouseSources/ListApp'
  )
)
const CustomersSettingsWarehouseSourcesEdit = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsWarehouseSourcesEdit" */ './Settings/WarehouseSources/EditApp'
  )
)
const CustomersSettingsWarehouseSourcesCreate = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsWarehouseSourcesCreate" */ './Settings/WarehouseSources/CreateApp'
  )
)
const CustomersSettingsAPIAccess = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsAPIAccess" */ './Settings/APIAccess'
  )
)
const CustomersSettingsIdentityResolution = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsIdentityResolution" */ './Settings/IdentityResolution'
  )
)
const CustomersSettingsFeatures = loadable(() =>
  import(
    /* webpackChunkName: "CustomersSettingsFeatures" */ './Settings/Features'
  )
)
const CustomersDestinationsApp = loadable(() =>
  import(/* webpackChunkName: "CustomersDestinationsApp" */ './DestinationsApp')
)
const CustomersDestinationsViewApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersDestinationsViewApp" */ './DestinationsApp/ViewApp'
  )
)
const CustomersAudiencesApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesApp" */ './Audiences/AudiencesApp'
  )
)
const CustomersAudiencesViewApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesViewApp" */ './Audiences/Audience/ViewApp'
  )
)
const CustomersAudiencesOverviewApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesOverviewApp" */ './Audiences/Audience/OverviewApp'
  )
)
const CustomersAudiencesEditApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesEditApp" */ './Audiences/Audience/EditApp'
  )
)
const CustomersAudiencesSettingsApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesSettingsApp" */ './Audiences/Audience/SettingsApp'
  )
)
const CustomersAudiencesCreateApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersAudiencesCreateApp" */ './Audiences/CreateApp'
  )
)
const CustomerTraitsApp = loadable(() =>
  import(/* webpackChunkName: "CustomerTraitsApp" */ './Traits/TraitsApp')
)
const CustomersTraitsCreateApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersTraitsCreateApp" */ './Traits/CreateApp'
  )
)
const CustomersTraitsViewApp = loadable(() =>
  import(/* webpackChunkName: "CustomersTraitsViewApp" */ './Traits/ViewApp')
)
const CustomersTraitsOverviewApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersTraitsOverviewApp" */ './Traits/OverviewApp/OverviewApp'
  )
)
const CustomersTraitsSettingsApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersTraitsSettingsApp" */ './Traits/SettingsApp'
  )
)
const CustomersTraitsEditApp = loadable(() =>
  import(/* webpackChunkName: "CustomersTraitsEditApp" */ './Traits/EditApp')
)
const CustomersExplorerApp = loadable(() =>
  import(/* webpackChunkName: "CustomersExplorerApp" */ './ExplorerApp')
)
const CustomersProfileSheetApp = loadable(() =>
  import(
    /* webpackChunkName: "CustomersProfileSheetApp" */ './ProfileApp/ProfileSheetApp'
  )
)

const personasRoutes = (
  <>
    <IndexRedirect to="explorer" />
    <Route
      path="explorer"
      disableAutoPageTracking
      component={CustomersExplorerApp}
    >
      <Route path=":profileId" component={CustomersProfileSheetApp} />
    </Route>
    <Route path="new" component={CustomersCreateApp} />
    <Route path="traits" component={CustomerTraitsApp} />
    <Route path="traits/new" component={CustomersTraitsCreateApp} />
    <Route path="traits/:traitId" component={CustomersTraitsViewApp}>
      <IndexRedirect to="overview" />
      <Route path="overview" component={CustomersTraitsOverviewApp} />
      <Route path="edit" component={CustomersTraitsEditApp} />
      <Route path="settings" component={CustomersTraitsSettingsApp} />
    </Route>
    <Route path="destinations" component={CustomersDestinationsApp}>
      <Route path=":destinationId" component={CustomersDestinationsViewApp} />
    </Route>
    <Route path="settings" component={CustomersSettings}>
      <Route path="labels" component={CustomersSettingsLabelsApp} />
      <IndexRedirect to="sources" />
      <Route path="sources" component={CustomersSettingsSources} />
      <Route
        path="connection-policy"
        component={CustomersSettingsConnectionPolicyApp}
      />
      <Route
        path="warehouse-sources/new"
        component={CustomersSettingsWarehouseSourcesCreate}
      />
      <Route
        path="warehouse-sources"
        component={CustomersSettingsWarehouseSourcesList}
      >
        <Route
          path=":warehouseSourceId"
          component={CustomersSettingsWarehouseSourcesEdit}
        />
      </Route>
      <Route path="api-access" component={CustomersSettingsAPIAccess} />
      <Route
        path="identity-resolution"
        component={CustomersSettingsIdentityResolution}
      />
      <Route path="features" component={CustomersSettingsFeatures} />
    </Route>

    <Route path="audiences" component={CustomersAudiencesApp} />
    <Route path="audiences/new" component={CustomersAudiencesCreateApp} />
    <Route path="audiences/:audienceId" component={CustomersAudiencesViewApp}>
      <IndexRedirect to="overview" />
      <Route
        path="overview"
        disableAutoPageTracking
        component={CustomersAudiencesOverviewApp}
      />
      <Route path="edit" component={CustomersAudiencesEditApp} />
      <Route path="settings" component={CustomersAudiencesSettingsApp} />
    </Route>
  </>
)

export default (
  <>
    <Redirect path="customers" to="personas" />
    <Redirect path="customers/explorer" to="personas/explorer" />
    <Redirect path="customers/traits" to="personas/traits" />

    <Route
      path="personas"
      component={CustomersApp}
      label="Personas"
      disableGlobalTopNav
      team="personas"
    >
      {personasRoutes}
      <Route path="spaces/:spaceSlug">{personasRoutes}</Route>
    </Route>
  </>
)
